// @flow
import React from 'react';
import classnames from 'classnames';

import { ICONS } from 'Components/utils/icon/icons';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';

import { themes } from './TextLink.themes';

export type TextLinkProps = {
  ariaHidden?: boolean,
  ariaLabel?: string,
  className?: string,
  color?: Colors,
  iconLeftName?: IconName,
  iconRightName?: IconName,
  isExternalLink?: boolean,
  label?: string,
  onClick?: (e: SyntheticEvent<>) => mixed,
  tabIndex?: number,
  target?: string,
  theme?: string,
  trackingData?: ?TrackingData,
  url?: string,
};

export function TextLink(props: TextLinkProps) {
  const {
    ariaHidden,
    ariaLabel,
    className,
    color,
    iconLeftName,
    iconRightName = ICONS.BOLDER_ARROW_FORTH,
    isExternalLink,
    label,
    onClick,
    tabIndex = 0,
    target,
    theme = 'default',
    trackingData,
    url,
  } = props;

  if (!label) return null;

  const { thIconLeft, thIconRight, thIconWidth, thLabel, thRoot } = themes[theme]({ color });

  return (
    <TrackClick
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      as={url ? DynamicLink : 'button'}
      className={classnames(className, 'reset-button inline-flex items-center', thRoot)}
      onClick={onClick}
      tabIndex={tabIndex}
      target={target}
      trackingData={trackingData}
      {...(url ? { url, isExternalLink } : { type: 'button' })}
    >
      {!!iconLeftName && (
        <Icon className={thIconLeft} hasRtl name={iconLeftName} width={thIconWidth} />
      )}
      <span className={thLabel}>{label}</span>
      {!!iconRightName && (
        <Icon className={thIconRight} hasRtl name={iconRightName} width={thIconWidth} />
      )}
    </TrackClick>
  );
}
